import styled from 'styled-components'

import { palette } from '../../../../styles/variables'
import { Text } from '../../../topography'

export const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  alignItems: 'stretch',
})

export const Item = styled.div(({ active, isBlackFriday }) => ({
  position: 'relative',
  border: `1px solid ${active ? palette.orange : palette.lightGray70}`,
  borderRadius: '2px',
  padding: '12px 12px 6px 12px',
  flex: 1,
  cursor: 'pointer',
  transition: 'border-color .3s ease, background-color .3s ease',
  marginTop: isBlackFriday ? '5px' : 0,
  '& *': {
    cursor: 'pointer',
  },
  '&:hover': {
    borderColor: palette.orange,
    backgroundColor: palette.orange10,
  },
}))

export const PriceContainer = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  marginBottom: '8px',
  gap: '4px',
})

export const PromotionLabel = styled.div(({ background }) => ({
  position: 'absolute',
  top: 0,
  right: '10px',
  padding: '5px 15px',
  backgroundColor: background || palette.darkGray,
  clipPath: 'polygon(0% 0%, 100% 0%, 96% 50%, 100% 100%, 0% 100%, 4% 50%)',
  transform: 'translateY(-50%)',
}))

export const PlanDescriptionContainer = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  paddingRight: '25px',
  '& b': {
    color: palette.darkGray70,
  },
}))

export const Badge = styled.div(({ backgroundColor = palette.gray10 }) => ({
  borderRadius: '10px',
  padding: '4px 6px',
  backgroundColor,
  flexShrink: 0,
  width: 'fit-content',
  maxWidth: '130px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '5px',
}))

export const BadgeContent = styled(Text)(({ color = palette.gray }) => ({
  fontSize: '10px',
  lineHeight: '12px',
  color,
  textTransform: 'uppercase',
}))
